module.exports = __webpack_public_path__ + "static/img/nekker1.0903a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/nekker1.png
// module id = DXJF
// module chunks = 0